var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      style: { zIndex: "601" },
      attrs: { width: "1000" },
      on: { "click:outside": _vm.hideDialog },
      model: {
        value: _vm.cartDialog,
        callback: function ($$v) {
          _vm.cartDialog = $$v
        },
        expression: "cartDialog",
      },
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-toolbar",
            {
              staticClass: "d-block",
              attrs: { color: "grey lighten-4", dense: "", flat: "" },
            },
            [
              _c("v-toolbar-title", { staticClass: "fw-600" }, [
                _vm._v(_vm._s(_vm.$t("add_to_cart"))),
              ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ms-auto",
                  attrs: { icon: "", fab: "", small: "" },
                  on: { click: _vm.hideDialog },
                },
                [_c("i", { staticClass: "las la-times fs-24" })]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-4 text-dark" },
            [
              _c("AddToCart", {
                attrs: {
                  "is-loading": _vm.loading,
                  "product-details": _vm.productDetails,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }